/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2022
 *
 *==================================================
 */
//Get current user's wish list
export const WISHLIST_GET_REQUESTED = "WISHLIST_GET_REQUESTED";
export const WISHLIST_GET_SUCCESS = "WISHLIST_GET_SUCCESS";
export const WISHLIST_GET_ERROR = "WISHLIST_GET_ERROR";
export const WISHLIST_RESET = "WISHLIST_RESET";
export const WISHLIST_DELETE = "WISHLIST_DELETE";
export const WISHLIST_DELETE_ITEM = "WISHLIST_DELETE_ITEM";
export const WISHLIST_MOVE_ITEMS = "WISHLIST_MOVE_ITEMS";
export const WISHLIST_MOVE_ITEMS_RESET = "WISHLIST_MOVE_ITEMS_RESET";
